// extracted by mini-css-extract-plugin
export default {"select":"select--ee65b5","select_fill":"select_fill--81a040"};